import { initializeApp } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendEmailVerification,
  signOut,
  onAuthStateChanged,
} from "firebase/auth";
import { getFirestore, doc, setDoc, getDoc, Timestamp } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { toast } from "sonner";

// Firebase konfigürasyonu
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyB6bJFoPB_orU7xw-bG0bZZJcZQLgnUIAA",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "yelten-platform.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "yelten-platform",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "yelten-platform.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "1013707112134",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:1013707112134:web:6578225cfb4c7d6c1b61c7",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-SYGJNBE0CE",
};

// Firebase uygulamasını başlat
let app;
try {
  app = initializeApp(firebaseConfig);
  console.log("Firebase başarıyla başlatıldı.");
} catch (error) {
  console.error("Firebase başlatılırken hata oluştu:", error.message);
  toast.error("Firebase başlatılamadı. Lütfen tekrar deneyin.");
  throw new Error("Firebase başlatılamadı. Lütfen yapılandırmayı kontrol edin.");
}

// Firestore, Authentication, Storage ve Functions servisleri
const db = getFirestore(app);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
const storage = getStorage(app);
const functions = getFunctions(app, 'us-central1');
console.log("Firebase Functions başlatıldı:", functions);

// GoogleAuthProvider ayarları
provider.addScope("profile");
provider.addScope("email");

// Kullanıcı kaydını Firestore'a kaydetme (yalnızca yeni kullanıcılar için)
const saveUserToFirestore = async (userId, name, exam) => {
  try {
    const userRef = doc(db, "users", userId);
    const userDoc = await getDoc(userRef);

    if (userDoc.exists()) {
      console.log(`User ${userId} already exists, skipping creation`);
      return;
    }

    await setDoc(userRef, {
      username: name,
      examType: exam,
      createdAt: Timestamp.now(),
      premium: false,
    }, { merge: true });

    localStorage.setItem("username", name);
    localStorage.setItem("examType", exam);
    localStorage.setItem("userId", userId);
    console.log(`Kullanıcı Firestore'a kaydedildi: ${userId}`);
  } catch (error) {
    console.error("Kullanıcı Firestore'a kaydedilirken hata:", error.message);
    toast.error("Kullanıcı kaydedilemedi. Lütfen tekrar deneyin.");
    throw new Error("Kullanıcı kaydedilemedi. Lütfen tekrar deneyin.");
  }
};

// Kullanıcı verilerini çekme
const getUserData = async (uid) => {
  try {
    const userRef = doc(db, "users", uid);
    const userDoc = await getDoc(userRef);
    if (userDoc.exists()) {
      return userDoc.data();
    }
    console.log(`Kullanıcı verisi bulunamadı: ${uid}`);
    return null;
  } catch (error) {
    console.error("Kullanıcı verisi çekilirken hata:", error.message);
    toast.error("Kullanıcı verileri alınamadı.");
    throw new Error("Kullanıcı verileri alınamadı.");
  }
};

// E-posta doğrulama maili gönderme
const sendEmailVerificationForUser = async (user) => {
  try {
    if (!user) {
      throw new Error("Kullanıcı oturumu bulunamadı.");
    }
    await sendEmailVerification(user, {
      url: process.env.REACT_APP_VERIFICATION_REDIRECT_URL || "https://yelten-platform.firebaseapp.com",
      handleCodeInApp: true,
    });
    console.log("Doğrulama e-postası gönderildi.");
    toast.success("Doğrulama e-postası gönderildi.");
  } catch (error) {
    console.error("E-posta doğrulama maili gönderilirken hata:", error.message);
    toast.error("Doğrulama e-postası gönderilemedi.");
    throw new Error("Doğrulama e-postası gönderilemedi.");
  }
};

// Export edilen modüller
export {
  app,
  db,
  auth,
  provider,
  storage,
  functions,
  saveUserToFirestore,
  getUserData,
  signInWithPopup,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendEmailVerificationForUser,
  signOut,
  onAuthStateChanged,
  Timestamp,
  doc,
  setDoc,
};